module.exports = __webpack_public_path__ + "img/fir-sat-cal.1aba4a2e.svg";